import { ref, onBeforeUnmount } from 'vue'

export function useMapMarkers(wrapperRef, caches, mapLevel) {
  const markers = ref([])

  const computeMarkers = () => {
    const svgEl = wrapperRef.value?.querySelector('svg')
    if (!svgEl) return

    if (mapLevel.value !== 'country') { markers.value = []; return }

    const centroids = caches.region?.centroid
    if (!centroids?.size) { markers.value = []; return }

    const ctm = svgEl.getScreenCTM()
    if (!ctm) return

    const rect  = wrapperRef.value.getBoundingClientRect()
    const point = svgEl.createSVGPoint()
    const next  = []
    centroids.forEach(({ cx, cy }, key) => {
      point.x = cx
      point.y = cy
      const screen = point.matrixTransform(ctm)
      next.push({ key, x: screen.x - rect.left, y: screen.y - rect.top, attr: 'region' })
    })
    markers.value = next
  }

  const clearMarkers = () => { markers.value = [] }

  let resizeObserver     = null
  let pendingResizeFrame = null

  const observeResize = () => {
    resizeObserver = new ResizeObserver(() => {
      if (pendingResizeFrame) return
      pendingResizeFrame = requestAnimationFrame(() => {
        pendingResizeFrame = null
        computeMarkers()
      })
    })
    resizeObserver.observe(wrapperRef.value)
  }

  onBeforeUnmount(() => {
    resizeObserver?.disconnect()
    if (pendingResizeFrame) cancelAnimationFrame(pendingResizeFrame)
  })

  return { markers, computeMarkers, clearMarkers, observeResize }
}
